import Loading from '@/components/Loading/index.vue';
import createLikeDirective from '@/directive/create-like-directive';

const loadingDirective = createLikeDirective(Loading);

export default loadingDirective;
